import NotInterestedIcon from '@mui/icons-material/NotInterested';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import { useState } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import ConfirmationModal from '~/components/ConfirmationModal';
import messages from './messages';
import { useDisableRoute } from '~/hooks/api/useDisableRoute';
import { useSnackbar } from '~/containers/Snackbar/SnackbarContext';
import { useNavigate } from '@tanstack/react-router';

type DisableRouteButtonProps = {
  routeId: number;
};

const DisableRouteButton = (props: DisableRouteButtonProps) => {
  const navigate = useNavigate();
  const intl = useIntl();
  const { showSnackbar } = useSnackbar();
  const routeDisableMutation = useDisableRoute(props.routeId, {
    onSuccess: () => {
      showSnackbar({
        message: intl.formatMessage(messages.disableSuccess),
      });
      navigate({ to: '/trolley-routes' });
    },
    onError: () => {
      console.log('onError');
      showSnackbar({
        message: intl.formatMessage(messages.disableFailure),
      });
    },
  });
  const [disableModalOpen, setDisableModalOpen] = useState(false);
  const toggleDisableModal = () => {
    setDisableModalOpen(!disableModalOpen);
  };
  return (
    <>
      <Tooltip title={<FormattedMessage {...messages.disableButton} />}>
        <IconButton
          edge="end"
          color="inherit"
          aria-label={intl.formatMessage(messages.disableButton)}
          onClick={toggleDisableModal}
          size="large"
        >
          <NotInterestedIcon />
        </IconButton>
      </Tooltip>
      <ConfirmationModal
        open={disableModalOpen}
        title={intl.formatMessage(messages.disableConfirmTitle)}
        text={<FormattedMessage {...messages.disableConfirmText} />}
        confirmLabel={<FormattedMessage {...messages.disableConfirmDelete} />}
        cancelLabel={<FormattedMessage {...messages.disableConfirmCancel} />}
        onCancel={toggleDisableModal}
        onConfirm={() => {
          if (!props.routeId) return;
          routeDisableMutation.mutate();
        }}
      />
    </>
  );
};

export default DisableRouteButton;
